export default __webpack_public_path__ + "static/media/ic_edit_24px.3aba1509.svg";